<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    title="Список ревизий"
    content-class="LKPublicationsFormdataRevisionsListModal"
    @closed="$emit('closed')"
  >
    <LKPublicationsFormdataRevisionsList
      :id="data.id"
      :form_template_id="form_template_id"
    />
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer from './LKPublicationsFormdataListModalContainer.vue'
import LKPublicationsFormdataRevisionsList from './LKPublicationsFormdataRevisionsList.vue'


export default {
  name: 'LKPublicationsFormdataRevisionsListModal',
  components: {
    LKPublicationsFormdataListModalContainer,
    LKPublicationsFormdataRevisionsList,
  },
  inheritAttrs: false,
  props: {
    form_template_id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'id' in prop
      ),
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataRevisionsListModal {
  width: 600px;
  margin-right: auto;
  margin-left: auto;
}
</style>
